module.exports = __webpack_public_path__ + "img/list_empty.3fefb0b7.png";